import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    fetchCategoryStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCategorySuccess: (state, action) => {
      state.loading = false;
      state.categories = action.payload;
    },

    fetchCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
} = categorySlice.actions;

export default categorySlice.reducer;